<script setup lang="ts">
import {inject, ref} from 'vue';
import {apps, LegacyOrder, legacyOrderKey} from '@hantera/portal-app';

import Rma from './Rma/Rma.vue'
import AppSlotView from "@/AppSlotView.vue";

const order = inject(legacyOrderKey, ref<LegacyOrder>(<any>{}));

</script>

<template>
  <div class="legacy-order-view-rmas">
    <AppSlotView :slot="apps.legacySlots.legacyOrder.rmas.first" />
    <Rma
      v-for="rma in order.rmas"
      :key="rma.rmaId"
      :data="rma"
      class="legacy-order-view-rmas__rma"
    />
  </div>
</template>

<style>
.legacy-order-view-rmas {
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: min-content;
  gap: 10px;
  margin: 5px;
}
</style>